import { useTaskNouns } from "hooks/use-task-nouns";
import React from "react";

export const TasksTabLabel: React.FC<unknown> = () => {
    const nouns = useTaskNouns();
    return <>{nouns.titlePlural}</>;
};
